const SIGNALFORGE_BASE =
  typeof import.meta !== 'undefined' &&
  (import.meta as { env?: { VITE_SIGNALFORGE_BASE_URL?: string } }).env
    ?.VITE_SIGNALFORGE_BASE_URL
    ? (import.meta as { env: { VITE_SIGNALFORGE_BASE_URL?: string } }).env
        .VITE_SIGNALFORGE_BASE_URL
    : 'https://nq-finintellect-rebalancer.prod.novaquantis.dev';

export const REBALANCING_LINKS = {
  finintellect: 'https://nq-finintellect-rebalancer.prod.novaquantis.dev',
  finintellectHealth: 'https://nq-finintellect-rebalancer.prod.novaquantis.dev/healthz',
  tradeEngine: 'https://nq-trade-engine.prod.novaquantis.dev/health',
  ledger: 'https://nq-ledger.prod.novaquantis.dev/health',
  signalForgeBase:
    SIGNALFORGE_BASE?.replace(/\/$/, '') ?? 'https://nq-finintellect-rebalancer.prod.novaquantis.dev',
  grafanaSignalForge:
    'https://grafana.novaquantis.dev/d/signalforge-activity/signalforge-activity',
} as const;

export function buildSignalForgeExplainUrl(brokerSymbol: string): string {
  const ticker = brokerSymbol.trim().toUpperCase();
  return `${REBALANCING_LINKS.signalForgeBase}/signalforge/explain/${encodeURIComponent(ticker)}`;
}
